// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';

// Définir le Height du slider au chargement
addEventListener("DOMContentLoaded", function () {
    const heightHeaderValue = document.querySelector('#site-header').offsetHeight
    const heightWpAdminbar = document.querySelector('#wpadminbar')
    const heightWpAdminbarValue = heightWpAdminbar ? heightWpAdminbar.offsetHeight : 0;
    const heightAll = heightHeaderValue + heightWpAdminbarValue
    const sliderTimeline = document.querySelector('.timeline-slider')

    if (sliderTimeline) {
        sliderTimeline.style.setProperty('--height-timeslider', `calc(100dvh - ${heightAll}px)`)
    }

});


const timelineSlider = document.querySelector('.timeline-slider')

if (timelineSlider) {

    const swiperTimelineNav = new Swiper('.timeline-slider__thumbs', {
        // configure Swiper to use modules
        slidesPerView: 3,
        freeMode: true,
        spaceBetween: 10,
        direction: 'horizontal',
        breakpoints: {
            1019: {
                slidesPerView: 8,
                direction: 'vertical',
            },
            820: {
                slidesPerView: 6,
                direction: 'horizontal',
            },
            768: {
                slidesPerView: 5,
                direction: 'horizontal',
            },
            640: {
                slidesPerView: 4,
                direction: 'horizontal',

            },
        },
    });


    const swiperTimeline = new Swiper('.timeline-slider__slider', {
        // configure Swiper to use modules
        direction: 'horizontal',
        watchOverflow: false,
        slidesPerView: 1,
        breakpoints: {
            1020: {
                direction: 'vertical',
            },
        },
        pagination: {
            el: ".timeline-slider__dots",
            //dynamicBullets: true,
            clickable: true,
        },
        thumbs: {
            swiper: swiperTimelineNav,
        },
        navigation: {
            nextEl: ".timeline-slider__button-next",
            prevEl: ".timeline-slider__button-prev",
        },
    });

}